import { Center } from '@chakra-ui/react';
import { FC, PropsWithChildren } from 'react';

export const Empty: FC<PropsWithChildren> = ({
  children = 'No classes for now',
}) => <Center h="100%">{children}</Center>;
